import {AfterViewInit, Component, ElementRef, Injector, OnInit, ViewChild} from '@angular/core';
import {appModuleAnimation, UrlHelper} from '@axilla/axilla-shared';
import {ThemesLayoutBaseComponent} from '@app/shared/layout/themes/themes-layout-base.component';
import {LayoutRefService} from '@metronic/app/core/_base/layout/services/layout-ref.service';
import {AppConsts} from '@shared/AppConsts';
import {of} from 'rxjs';
import {catchError, debounceTime, distinctUntilChanged, filter, tap} from 'rxjs/operators';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {Router} from '@angular/router';
import {WebshopService} from '../../../common/shop-system/services/webshop.service';
import {OrderStateService} from '@app/webshop/field-agent/shared/services/order-state.service';
import {BasePermissionDefinition} from '@shared/permission/base-permission-definition';
import {PermissionCheckerService} from '@node_modules/abp-ng2-module';
import {OffcanvasOptions} from '@metronic/app/core/_base/layout/directives/offcanvas.directive';
import {NgxSpinnerService} from '@node_modules/ngx-spinner';
import {FieldAgentOrderService} from '@app/webshop/field-agent/shared/services/field-agent-order.service';

@Component({
    templateUrl: './theme12-layout.component.html',
    selector: 'theme12-layout',
    animations: [appModuleAnimation()]
})
export class Theme12LayoutComponent extends ThemesLayoutBaseComponent implements OnInit, AfterViewInit {

    private readonly confirmationUrl = '/app/webshop/field-agent/order-submitted';
    private readonly orderDetailsUrl = '/app/webshop/order-details';
    private readonly orderOverviewUrl = '/app/webshop/order-overview';
    private readonly webshopDashboardUrl = '/app/webshop/dashboard';
    private readonly webshopCategoriesUrl = '/app/webshop/categories';
    private readonly webshopArticlesUrl = '/app/webshop/articles';

    toggle: any;

    menuCanvasOptions: OffcanvasOptions = {
        baseClass: 'kt-aside',
        overlay: true,
        closeBy: 'kt_aside_close_btn',
        toggleBy: [{
            target: 'kt_aside_mobile_toggler',
            state: 'kt-header-mobile__toolbar-toggler--active'
        }]
    };

    @ViewChild('ktHeader', {static: true}) ktHeader: ElementRef;

    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;
    get searchForm(): UntypedFormGroup {
        return this.webshopService.globalSearchForm;
    }
    query = '';

    spinnerService: NgxSpinnerService;

    constructor(
        injector: Injector,
        private layoutRefService: LayoutRefService,
        private _router: Router,
        private _webshopService: WebshopService,
        private _orderStateService: OrderStateService,
        private _fieldAgentOrderService: FieldAgentOrderService,
    ) {
        super(injector);

        this.spinnerService = injector.get(NgxSpinnerService);
    }

    count= 1;

    ngOnInit() {
        console.log('Oninit Theme12LayoutComponent');
        this.installationMode = UrlHelper.isInstallUrl(location.href);

        this.searchForm.get('filter').valueChanges.pipe(
            debounceTime(300),
            distinctUntilChanged(),
            catchError(error => of(`Caught an error: ${error.message}`))
        ).subscribe({
            next: (query) => {
                console.log(this.count++);
                this.search(query);
            },
            error: err => `Error: ${err.message}`,
            complete: () => console.log('Completed')
        });
    }
    ngAfterViewInit(): void {
        this.layoutRefService.addElement('header', this.ktHeader.nativeElement);
        this.initAsideToggler();
    }

    goHome() {
        event.preventDefault();

        if (this.isGuided) {
            this._fieldAgentOrderService.goHome();
        } else {
            window.location.href = '/';
        }
    }

    initAsideToggler(): void {
        this.toggle = new KTToggle('kt_aside_toggler', {
            target: 'body',
            targetState: 'kt-aside--minimize',
            togglerState: 'kt-aside__brand-aside-toggler--active'
        });
    }

    onSearchClick(): void {
        const query = this.searchForm.get('filter').value;
        this._updateQuery(query);
    }

    search(query?: any) {
        this.spinnerService.show();

        this.query = query || this.searchForm.get('filter').value;
        this._updateQuery(this.query);
        this._searchDetector();
    }

    clearInput() {
        this.searchForm.get('filter').setValue('');
        this.searchForm.get('filter').updateValueAndValidity();
    }

    get isSearchAvailable(): boolean {
        if (this._webshopService.isLegacyUi && this._webshopService.isSearchAvailable) {
            return true;
        }

        return this._webshopService.isSearchAvailable
            && !location.pathname.startsWith(this.webshopDashboardUrl)
            && !location.pathname.startsWith(this.webshopArticlesUrl)
            && !location.pathname.startsWith(this.webshopCategoriesUrl);
    }

    get showStates(): boolean {
        return this.isGuided
            && !location.pathname.startsWith(this.confirmationUrl)
            && !location.pathname.startsWith(this.orderDetailsUrl)
            && !location.pathname.startsWith(this.orderOverviewUrl);
    }


    private _updateQuery(query?: any) {
        if (query) {
            this._webshopService.globalSearchFilter = query;
        } else {
            this._webshopService.globalSearchFilter = '';
        }
    }

    private _searchDetector() {
        const path = window.location.pathname;

        if (path.startsWith('/app/webshop/articles')
            || path.startsWith('/app/webshop/categories')) {
            abp.event.trigger('app.globalSearch.loadData');
        } else {
            this._router.navigate(['app/webshop/dashboard']);

            abp.event.trigger('app.globalSearch.run');
        }
    }
}
